import { Map } from 'immutable';
import { $getRoot } from 'lexical';
import { confirmLexicalStateInTextComponent } from 'modules/draftjs2lexical';
import * as Models from 'models';
import { createLexicalTextEditor } from '../editors';

export function getCleanTextLexical(textComponent: Models.TextComponent | Models.TextComponentMap): string {
  const confirmedTextComponent = confirmLexicalStateInTextComponent(textComponent, null);
  let lexicalState: string | undefined | null;
  if (Map.isMap(confirmedTextComponent)) {
    lexicalState = (confirmedTextComponent as Models.TextComponentMap).get('lexicalState');
  } else {
    ({ lexicalState } = confirmedTextComponent as Models.TextComponent);
  }

  if (!lexicalState) {
    return '';
  }

  const editor = createLexicalTextEditor(lexicalState);

  return editor.read(() => $getRoot().getTextContent());
}
